import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Checkbox, Form, Label } from 'semantic-ui-react'
import axios from 'axios';
import './style.css';
import {
  Card,
  Table,
  Button,
  Stack,
  Paper,
  Avatar,
  Popover,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  TablePagination,
} from '@mui/material';
import Scrollbar from '../../components/scrollbar';
import { Link } from 'react-router-dom';

export default function Create(props) {
	
	const navigate  = useNavigate();
	
	const [broj, setBroj] = useState('');	
	const [huntingclubId, setHuntingClubId] = useState('');
	const [naziv, setNaziv] = useState('');
	const [lokacija, setLokacije] = useState('');
	const [datum, setDatum] = useState('');
	const [opis, setOpis] = useState('');
    const [izvjestaj, setIzvjestaj] = useState('');	
		
	const postData = () => {	
	
		axios.post(`http://89.46.196.228:3000/api/meetings`,
			{
				"broj": broj,
				"huntingclubId": huntingclubId,
				"naziv": naziv,
				"lokacija": lokacija,
				"datum": datum,
				"opis": opis,
				"izvjestaj": izvjestaj
			}
			).then(() => {
				props.handler();
            // navigate('/dashboard/app')
        })
	}
		
    return (
		<Container maxWidth="xl">
        <Card>
          <Scrollbar>
		  
		    <TableContainer sx={{ minWidth: 800 }}>
			
              <Table style={{ tableLayout: 'fixed', color: "FF00FF" }}>
			  
                <TableBody>
        
                <TableRow>
				
                    <TableCell component="th" scope="row" >
        				<Form.Field>
							<Label>Broj</Label>
							<input placeholder='Broj' onChange={(e) => setBroj(e.target.value)}/>
						</Form.Field>
                     </TableCell>
						
					<TableCell component="th" scope="row" >
        				<Form.Field>
							<Label>Lovačko društvo</Label>
							<input placeholder='Lovačko društvo' onChange={(e) => setHuntingClubId(e.target.value)}/>
						</Form.Field>
                    </TableCell>
					
                    <TableCell component="th" scope="row" >
        				<Form.Field>
							<Label>Naziv</Label>
							<input placeholder='Naziv' onChange={(e) => setNaziv(e.target.value)}/>
						</Form.Field>
                     </TableCell>

                    <TableCell component="th" scope="row" >
        				<Form.Field>
							<Label>Lokacija</Label>
							<input placeholder='Lokacija' onChange={(e) => setLokacije(e.target.value)}/>
						</Form.Field>
                     </TableCell>
						
					<TableCell component="th" scope="row" >
        				<Form.Field>
							<Label>Datum</Label>
							<input placeholder='Datum' onChange={(e) => setDatum(e.target.value)}/>
						</Form.Field>
                    </TableCell>
					
                    <TableCell component="th" scope="row" >
        				<Form.Field>
							<Label>Opis</Label>
							<input placeholder='Opis' onChange={(e) => setOpis(e.target.value)}/>
						</Form.Field>
                     </TableCell>
					 
                    <TableCell component="th" scope="row" >
        				<Form.Field>
							<Label>Izvještaj</Label>
							<input placeholder='Izvještaj' onChange={(e) => setIzvjestaj(e.target.value)}/>
						</Form.Field>
                     </TableCell>
						
                </TableRow>

                <TableRow>
                    <TableCell component="th" scope="row" >
						<Button onClick={postData} type='submit'>Spasi</Button>
                     </TableCell>			
                </TableRow>
				
                </TableBody>
				
              </Table>
			  
            </TableContainer>
			
          </Scrollbar>

        </Card>
        </Container>
    )
}